export const menuTabs = {
    RECENT: 'Recent',
    SEARCH: 'Search',
    UPLOAD: 'Upload',
    LINK: 'Link',
};
